import { useUIContext } from 'lib/context/UIContext/UIContext';
import { cn, inRn, mString } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

export const TableFooterSummaryItem = ({
  label,
  value,
  color = 'neutral-600',
  className,
  valueClassName
}) => {
  return (
    <div className={cn('flex h-9 items-center justify-between gap-2', className)}>
      <Typography variant="label" size="medium" weight="medium" color={color}>
        {label}
      </Typography>
      <Typography variant="label" size="medium" color={color} className={valueClassName}>
        {mString(value)}
      </Typography>
    </div>
  );
};

const TableFooterSummary = ({ colSpan, totals }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  if (isMobile) return null;

  const currentAmountDue = inRn(totals?.balance) + inRn(totals?.totalPaid);

  return (
    <tr>
      <td className="text-right align-top" colSpan={colSpan}>
        <div className="mt-6 inline-flex w-[332px] flex-col justify-between pb-[14px] text-right sm:w-full">
          <TableFooterSummaryItem
            label="Previous payments"
            value={inRn(totals?.previousPayments)}
          />
          <TableFooterSummaryItem label="Current amount due" value={currentAmountDue} />
          <TableFooterSummaryItem
            label="Amount paid"
            value={inRn(totals?.totalPaid)}
            className="border-0 border-t border-solid border-neutral-200"
            color="neutral-900"
          />
          <TableFooterSummaryItem
            label="Remaining balance"
            value={inRn(totals?.remainingBalance)}
          />
        </div>
      </td>
    </tr>
  );
};

export default TableFooterSummary;
